

import React from "react";
import "../../styles/Gallery.css";
import galleryImage from "../../images/gallery-slider.jpg"; // Import the image

const Gallery = () => {
  return (
    <div className="gallery-container">
      {/* Image Slider */}
      <div className="image-slider">
        <img src={galleryImage} alt="Gallery Slider" />
      </div>

      {/* Coming Soon Animation */}
      <div className="coming-soon-container">
        <p className="coming-soon-text">Coming Soon...</p>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          {/* Left Section - CIN & Links */}
          <div className="footer-left">
            <p>CIN Number: U63030KA2022PTC161825</p>
            <p>
              <a href="/privacy-statement" className="footer-link">Privacy Statement</a> | 
              <a href="/terms-of-use" className="footer-link"> Terms Of Use</a>
            </p>
          </div>

          {/* Center - Copyright */}
          <div className="footer-center">
            <p>© {new Date().getFullYear()} ONEVEGA Systems (India) Pvt Ltd.</p>
          </div>

          {/* Right Section - Registered Office */}
          <div className="footer-right">
            <p><strong>Registered Office</strong></p>
            <p>Puyvast Logistics Pvt. Ltd.</p>
            <p>PuyVast House </p>
            <p>4th Floor ,#6, Harris Road, Benson Town,<br></br> Bangalore - 560 046.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};
export default Gallery;